import { render } from "./OuterDetail.vue?vue&type=template&id=40acaef6&scoped=true&ts=true"
import script from "./OuterDetail.vue?vue&type=script&lang=ts"
export * from "./OuterDetail.vue?vue&type=script&lang=ts"

import "./OuterDetail.vue?vue&type=style&index=0&id=40acaef6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40acaef6"]])

export default __exports__